import { TokenSymbolSchema } from "../shared";
import { StandardizedChainSchema } from "./exchange";
import { z } from "zod";

export type Currencies = {
  updatedAt: string;
  currencies: {
    fiat: string[];
    crypto: string[];
  };
};

export type CurrenciesResponse = {
  data: Currencies | null;
};

export type Rates = {
  base: string;
  rates: object;
};

export type RatesV2 = {
  base: string;
  rates: Record<string, number>;
};

export type RatesResponse = {
  data: RatesV2 | null;
};

export const TokenPriceSchema = z.object({
  tokenSymbol: TokenSymbolSchema,
  average: z.number().finite(),
  exchanges: z.record(z.string(), z.number().finite().nullable()), // in rare case it is null
});

export type TokenPrice = z.infer<typeof TokenPriceSchema>;

export const TokenPriceDataByTokenSymbolSchema = z.record(z.string(), TokenPriceSchema);
export type TokenPriceDataByTokenSymbol = z.infer<typeof TokenPriceDataByTokenSymbolSchema>;

export const TokensSchema = z.object({
  updatedAt: z.string(),
  tokens: TokenPriceDataByTokenSymbolSchema,
});
export type Tokens = z.infer<typeof TokensSchema>;

export const TokenPriceResponseSchema = z.object({
  data: z
    .object({
      updatedAt: z.string(),
      tokens: z.array(TokenPriceSchema),
    })
    .nullable()
    .optional(),
});

export type TokenPriceResponse = z.infer<typeof TokenPriceResponseSchema>;

export const ExchangeToStandardizedChainsMappingSchema = z.record(z.string(), z.array(StandardizedChainSchema));

export type ExchangeToStandarizedChainsMapping = z.infer<typeof ExchangeToStandardizedChainsMappingSchema>;

export type PricesByTokenSymbol<T extends number | string = number> = {
  [tokenSymbol: string]: T;
};
